<article>
  <h3>
    Or something else?
  </h3>
  <p>
    Some other possible factors that contribute to the difference in coverage: whether the shooting was linked to the election coverage; whether there was another shooting right before or after; whether there was other big news on the same day; and the size of the city where the shooting happened.
  </p>
</article>
<article>
  <h2>
    Media’s decision making signals what’s more worthy
  </h2>
  <p>
    Since all shootings have substantially different profiles, it is difficult to find a single answer to “Why are some shootings more newsworthy than others?” Although the number of victims, as well as other factors -- shooting locations, the profiles of shooters and victims, and whether they were connected with hate crimes or terrorism -- contribute to determine the coverage size in some ways, they are complicatedly related to each other and other factors.
  </p>
  <p>
    But it is clear that there is a general trend where workplace shootings and those involving domestic violence have been underreported, while shootings linked to terrorism and hate have been covered heavily.
  </p>
  <p>
    This is the result of choices that the editors of the Times have made, and it signals to readers that some shootings are more worthy of attention than the others. The media’s decision making on what, how much to cover, and where to place the story, shapes a narrative of importance of news events, building the reader’s perception of what’s important.
  </p>
  <p>
    Are victims of domestic violence less important than those of hate crimes? Should we be more concerned with violent acts by extremists than bad relationships with our family or coworkers? There is no single answer, but journalists are constantly tasked to make these difficult decisions. 
  </p>
  <p>
    Since all mass shootings are horrific tragedies and involve multiple murders by definition, they need media’s particularly careful decision making in the amount and profile of coverage.
  </p>
</article>

<style>
  article {
    margin: 10em auto;
  }
</style>